import { render, staticRenderFns } from "./AttributeFieldFilterItem.vue?vue&type=template&id=4fc0d464&scoped=true&"
import script from "./AttributeFieldFilterItem.vue?vue&type=script&lang=js&"
export * from "./AttributeFieldFilterItem.vue?vue&type=script&lang=js&"
import style0 from "./AttributeFieldFilterItem.vue?vue&type=style&index=0&id=4fc0d464&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc0d464",
  null
  
)

export default component.exports